import { createFileRoute } from '@tanstack/react-router';
import { ClaimsTable } from '../../../../features/insurance/claims/table';
import { getClaimsOptions } from '../../../../features/insurance/claims/queryOptions';
import { validateSearch } from '../../../../utils/pagination';

export const Route = createFileRoute(
  '/_authenticated/insurances/$guid/_layout/claims',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getClaimsOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const data = Route.useLoaderData();

  return (
    <div className="col-span-full flex items-center justify-between">
      <ClaimsTable claims={data} />
    </div>
  );
}
